<template>
  <div class="header-nav__item header-nav__item__notifications pos-relative no-selection js-toggle-notifications"
       :class="{ active: show}" @click="toggle($event)" v-on-clickaway="close">
    <div class="inline-block" :class="{'animated swing infinite': unReadCounter}">
      <span class="icon-bell js-toggle-notifications" style="margin-right:0;font-size: 13px"></span>
    </div>
    <div class="notify-number js-toggle-notifications" v-show="unReadCounter">{{ unReadCounter }}</div>
    <transition name="fade">
      <div class="notifications_list pos-absolute bg-white rounded" v-if="show">
        <div class="notifications__header popup_header">
          <h4 class="left marg-10-left">{{ unReadCounter }} {{ $t('vue2.notifications.notifications') }}</h4>
          <div class="notifications__header__tabs">
            <button class="bttn right" :class="{bttn_active: onlyUnreadMessagesActive}"
                    @click="getMessagesUnread">{{ $t('vue2.notifications.unread') }}

            </button>
            <button class="bttn right" :class="{bttn_active: !onlyUnreadMessagesActive}"
                    @click="getMessages">{{ $t('vue2.notifications.all') }}
            </button>
          </div>
        </div>
        <div class="notifications__body js-notifications-body-scroll">
          <div>
            <Loader bg-color="#fff" :isSmall="true" v-if="isInitialLoad"></Loader>
            <div class="pad-20 center" v-show="messages.length === 0" v-else>
              <div class="icon-checkmark-circle marg-10-bottom" style="font-size: 22px"></div>
              {{ $t('vue2.notifications.no_new_notifications') }}
            </div>
            <div v-for="(message, index) in messages" :key="message.id" class="notifations__body__message clearfix overflow pos-relative">
              <a :href="message.link" class="flex" :class="{is_read: message.read}">
                <div class="notifications__message__image-wrapper"
                     @click="readStatusRead($event, index, message.id, true)">
                  <img :src="message.user.profile_image_thumb" class="notifications__body__message__image rounded">
                </div>
                <div class="notifications__body__message__header"
                     @click="readStatusRead($event, index, message.id, true)"><p
                    class="text-dark bold marg-10-bottom">{{ message.header }}</p>
                  <p class="text-dark">{{ message.body }}</p>
                  <div class="notifications_body__message__footer">
                    <span>{{ $t('vue2.notifications.sent_from') }} {{
                        message.user.name
                      }} - {{ message.created_at | fromNow }}</span>
                  </div>
                </div>
                <div class="notifications__body__message__isread css_show_tooltip"
                     @click="changeReadStatus($event, index, message.id,!message.read)">
                  <div class="mark_as_read" :class="{is_read: message.read}">
                    <span class="icon-checkmark4"></span>
                  </div>
                </div>
              </a>
            </div>
          </div>
          <div v-observe-visibility="handleScrolledToBottom" div class="message-loader" v-if="messages.length > 4 && !isAllLoaded">
            <Loader bg-color="#fff" style="margin: 0 auto" :isSmall="true"></Loader>
          </div>
        </div>
        <div v-show="unReadCounter" class="notifications__footer box-sizing">
        <span @click="markAllAsRead" class="pointer pad-10-0 notifications__footer__link ">
          <span class="icon-checkmark-circle marg-10-right"></span>
          {{ $t('vue2.notifications.mark_all_as_read') }}
        </span>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import docendo from './../docendo'
import {mixin as clickaway} from 'vue-clickaway'
import Loader from './common/Loader'

export default {
  components: {Loader},
  mixins: [clickaway],
  data () {
    return {
      onlyUnreadMessagesActive: false,
      show: false,
      messages: [],
      unReadCounter: '',
      lastId: '',
      isAllLoaded: false,
      isInitialLoad: true
    }
  },
  methods: {
    handleScrolledToBottom (isVisible) {
      if (!isVisible) {
        return
      }
      this.getMessagesBefore(this.lastId)
    },
    close () {
      this.show = false
      this.messages = []
    },
    open () {
      this.show = true
      this.getMessages()
    },
    toggle (e) {
      // toggle if menu-item
      if (e.target.classList.contains('js-toggle-notifications')) {
        if (!this.show) {
          this.open()
        } else {
          this.close()
        }
      }
    },
    getMessages () {
      this.isInitialLoad = true
      this.onlyUnreadMessagesActive = false
      docendo.getNotificationsList(5, this.receiveMessages)
    },
    getMessagesUnread () {
      this.onlyUnreadMessagesActive = true
      docendo.getNotificationsListUnread(5, true, this.receiveMessages)
    },
    getMessagesBefore (id) {
      if (!this.onlyUnreadMessagesActive) {
        docendo.getNotificationsBefore(5, id, this.pushMessages)
      } else {
        docendo.getNotificationsUnreadBeforeId(5, true, id, this.pushMessages)
      }
    },
    receiveMessages (messages) {
      this.messages = messages
      this.isAllLoaded = false
      this.isInitialLoad = false
      // stop if no more message
      if (messages < 1) {
        this.isAllLoaded = true
        return
      }
      this.lastId = messages[messages.length - 1].id // update last id
    },
    pushMessages (messages) {
      // stop if no more message
      if (messages < 1) {
        this.isAllLoaded = true
        return
      }
      this.lastId = messages[messages.length - 1].id // update last id
      this.messages = this.messages.concat(messages)
    },
    readStatusRead (e, index, id, read) {
      if (this.messages[index].read === false) {
        this.unReadCounter === 0 ? this.unReadCounter = '' : this.unReadCounter = this.unReadCounter - 1
      }
      this.messages[index].read = true
      docendo.updateNotification(id, {read: read}, this.updateMessage)
    },
    changeReadStatus (e, index, id, read) {
      e.preventDefault() // don't click link
      read === true ? this.unReadCounter = this.unReadCounter - 1 : this.unReadCounter++

      this.messages[index].read = !this.messages[index].read
      docendo.updateNotification(id, {read: read}, data => {
        this.updateMessage(data)
      })
    },
    updateMessage (data) {
      console.log('updateMessage', data)
    },
    markAllAsRead () {
      // mark all in vue as read
      for (var i = 0; i < this.messages.length; i++) {
        this.messages[i].read = true
      }
      this.unReadCounter = 0
      docendo.markAllNotificationsAsRead()
    },
    unreadCount () {
      docendo.notificationsUnreadCount(this.updateUnreadCount)
    },
    updateUnreadCount (count) {
      count >= 1 ? this.unReadCounter = count : this.unReadCounter = ''
    }
  },
  mounted () {
    this.unreadCount()
    docendo.bind('new_notification', data => {
      this.unreadCount()
    })
  }
}
</script>

<style>
@import ".././assets/css/variables.css";

.notify-number {
  position: absolute;
  background: var(--orange);
  color: white;
  width: 18px;
  height: 18px;
  font-weight: 100;
  line-height: 16px;
  border-radius: 50%;
  top: 4px;
  text-align: center;
  right: 5px;
  border: 1px solid white;
  font-size: 9px;
}

.header-nav__item__notifications {
  border-top: 2px solid transparent;
  border-right: 1px solid #e6e8ef;
}

.header-nav__item__notifications:hover, .header-nav__item__notifications.active {
  border-top: 2px solid var(--blue);
  background: #F6F7F8;
  transition: 0.2s;
}

.notifications_list {
  top: 53px;
  right: -1px;
  z-index: 10000;
  width: 450px;
  text-align: center;
  min-width: 160px;
  margin: 0;
  line-height: 1em;
  border-top-right-radius: 0;
  list-style: none;
  font-size: 13px;
  text-align: left;
  background-color: #fff;
  border: 1px solid #ededed;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  background-clip: padding-box;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.13);
  will-change: opacity;
}

.notifications__header {
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  line-height: 55px;
  background: #f6f7f8;
  overflow: hidden;
  color: #3d4340;
  border-bottom: 1px solid #d8d8d8;
  text-align: center;
}

.notifications__header .notifications--close {
  top: 10px;
  right: 10px;
}

.notifications__body {
  text-transform: initial;
  overflow-y: auto;
  max-height: 350px;
  -webkit-overflow-scrolling: touch;
}

.notifations__body__message {
  border-bottom: 1px solid #d8d8d8;
}

.notifations__body__message:last-child {
  border-bottom: none;
}

.notifations__body__message a {
  font-weight: initial;
  background: transparent;
  border-left: 2px solid transparent;
  width: 100%;
}

.notifations__body__message a.is_read {
  opacity: 0.85;
  background: #F6F7F8;
}

.notifations__body__message a:hover {
  border-color: var(--blue);
  -webkit-transition: 0.2s;
  transition: 0.2s;
  color: initial !important;
}

.notifications__message__image-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20%;
}

.notifications__body__message__image {
  width: 45px;
  height: 45px;
}

.notifications__body .notifications__body__message__header {
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  flex-direction: column;
  width: 70%;
  padding: 20px 0
}

.notifications_body__message__footer {
  color: #a3a3a3;
  font-size: 11px;
  margin-top: 10px;
}

.notifications__header__tabs {
  float: right;
  margin: 12px 10px;
}

.notifications__header__tabs .bttn {
  font-size: 10px;
  background: #ffffff;
  height: 28px;
}

.notifications__header__tabs .bttn.bttn_active {
  background: #E4E4E4;
}

.notifications__header__tabs > button:last-child {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right: 1px solid transparent;
}

.notifications__header__tabs > button:nth-child(1) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.notifications__body__message__isread {
  width: 10%;
  padding: 20px 0;
}

.mark_as_read {
  position: relative;
  display: block;
  color: white;
  border-radius: 50%;
  border: 1px solid var(--blue);
  width: 21px;
  font-size: 12px;
  height: 21px;
  text-align: center;
  line-height: 22px;
  margin: 0 auto;
}

.mark_as_read.is_read {
  background: #CCCCCC;
  border: 1px solid #CCCCCC;
}

.mark_as_read .tooltip {
  top: -1px;
  right: 28px;
  background: rgba(61, 67, 64, 1);
  width: 105px;
}

.mark_as_read .tooltip:after {
  left: 100%;
  top: 50%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
  border-color: rgba(0, 0, 0, 0);
  border-left-color: rgba(61, 67, 64, 1);
  border-width: 5px;
  margin-top: -5px;
}

.notifications__footer {
  font-size: 12px;
  text-transform: initial;
  text-align: left;
  padding: 10px;
  background-color: #f6f7f8;
  border-radius: 0 0 4px 4px;
  width: 100%;
  border-top: 1px solid #d8d8d8;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .1s ease;
  opacity: 1;
}

.fade-enter, .fade-leave-active {
  opacity: 0;
}

.notifications__footer__link {
  transition: color 0.3s;
}

.notifications__footer__link:hover {
  color: var(--blue);
}

.message-loader {
  border-top: 1px solid #d8d8d8;
  padding: 20px 0;
}
</style>



// WEBPACK FOOTER //
// Notifications.vue?054c7df8